import { MDXRemote } from 'next-mdx-remote';
import React from 'react';
import { HeaderButton, PDFIcon } from './LayoutUtilities';

export function PDFbutton({ buttontext = 'Default', url = '#' }) {
  return (
    <div className="mt-3">
      <HeaderButton
        headerButtonText={buttontext}
        linkTo={url}
        icon={<PDFIcon />}
        buttonColor={undefined}
      />
    </div>
  );
}

export const ContentPage = props => {
  return (
    <>
      <div className="relative py-16 overflow-hidden">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto ">
            <h1 className="mt-2 block text-h1 text-text-primary">
                {props.title}
            </h1>
          </div>
        </div>
      </div>
      <div className="mt-6 text-text-secondary p-4 mx-auto max-w-3xl">
        <figure>
          <img
            className="w-full rounded-2xl"
            src={props.heroImage.url}
            alt={props.title}
          />
          {props.heroImage.figureCaption ? (
            <figcaption className="text-center py-4">
              {props.heroImage.figureCaption}
            </figcaption>
          ) : (
            ''
          )}
        </figure>
        <p className="mt-8 text-base lg:text-xl text-text-secondary leading-8">
          {props.abstract}
        </p>
        <div className="flex-grow border-t mt-4 border-border"></div>

        {props?.content ? (
          <div className="prose lg:text-lg mx-auto text-start mt-12 mb-8">
            {props.content ? <MDXRemote {...props.mdxSource} /> : ''}
          </div>
        ) : (
          ''
        )}
        {props.pdFs.length > 0 ? (
          <div className="text-lg flex flex-col items-center text-text-secondary">
            <p className="text-center">Download attached PDF</p>
            {props.pdFs.map((item, index) => (
              <PDFbutton
                key={index + 'pdf'}
                url={item.url}
                buttontext={'Download'}
              />
            ))}
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default ContentPage;
